import { useAuth } from "react-oidc-context";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { SaveCurrentPath } from "../Core";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";

export const SignIn = () => {
    const { user, signinRedirect } = useAuth();
    const history = useHistory();
    const client = useWebPortalLegacyClient();

    React.useEffect(() => {
        if (!user) {
            SaveCurrentPath(history);
            signinRedirect();
        }
    }, []);

    return null;
}
